import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgCuisine = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		id="cuisine_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>
				{
					`.prestation_cls_fill_none,.prestation_cls_fill_none-2{stroke-miterlimit:10;fill:none;stroke:${color};stroke-width:10px}.prestation_cls_fill_none-2{stroke-miterlimit:40}`
				}
			</style>
		</defs>
		<path
			className="prestation_cls_fill_none"
			d="M95.67 241.83V231.2c0-5.87 4.76-10.63 10.63-10.63s10.63 4.76 10.63 10.63v31.89"
		/>
		<path
			className="prestation_cls_fill_none-2"
			d="M63.78 263.09h106.3v85.04H63.78zM116.93 348.13v-85.04"
		/>
		<path
			className="prestation_cls_fill_none"
			d="M95.67 305.61h10.63M127.56 305.61h10.63"
		/>
		<path
			className="prestation_cls_fill_none-2"
			d="M329.61 252.4c0 5.87 4.76 10.63 10.63 10.63 5.87 0 10.63-4.76 10.63-10.63M265.66 252.4c0 5.87 4.76 10.63 10.63 10.63 5.87 0 10.63-4.76 10.63-10.63"
		/>
		<path
			className="prestation_cls_fill_none"
			d="m276.29 146.16-21.17 31.89h106.3l-21.18-31.89h-63.95zM85.04 71.75v85.04M127.56 114.27V71.75M141.84 135.53h-28.35l-.21-7.09c0-7.83 6.35-14.17 14.17-14.17 7.83 0 14.17 6.35 14.17 14.17l.21 7.09ZM99.32 178.05H70.97l-.21-7.09c0-7.83 6.35-14.17 14.17-14.17 7.83 0 14.17 6.35 14.17 14.17l.21 7.09Z"
		/>
		<path className="prestation_cls_fill_none-2" d="M223.23 71.75v74.41" />
		<path
			className="prestation_cls_fill_none"
			d="M233.86 114.27h10.63M212.6 114.27h-10.63"
		/>
		<path
			className="prestation_cls_fill_none-2"
			d="M255.12 146.16h-85.04V71.75h106.3v21.26l-.09 21.26"
		/>
		<path
			className="prestation_cls_fill_none"
			d="M276.29 71.75h63.86v74.41h-63.86z"
		/>
		<path
			className="prestation_cls_fill_none-2"
			d="M255.12 347.93v-85.04M233.86 263.09h127.56v85.04H233.86zM233.86 353.44l-63.78-5.31v-85.04l63.78-5.38v95.73zM212.6 305.61h-10.63"
		/>
		<path
			className="prestation_cls_fill_none-2"
			d="M255.12 263.09h106.3v42.52h-106.3zM297.64 284.35h21.26M297.64 326.87h21.26"
		/>
	</svg>
)
export default SvgCuisine
